import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import style from "../../../../sass/pages/shipments/shipments-list.module.scss";
import { selectShipmentsUploadingStatus, selectShipmentUploadingError, selectShownShipments, uploadShipments } from "../../shipmentsSlice";
import ShipmentsTableItem from "./ShipmentsTableItem";
import { pushAlert } from "../../../alerts/alertSlice";
import { useTranslation } from "react-i18next";
import GreenSpinner from "../../../../components/loaders/GreenSpinner";

const ShipmentsTable = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const shipments = useSelector(selectShownShipments)
  const status = useSelector(selectShipmentsUploadingStatus)
  const error = useSelector(selectShipmentUploadingError)

  useEffect(() => {
    dispatch(uploadShipments())
  }, [dispatch])

  useEffect(() => {
    if (error) {
      dispatch(pushAlert({
        type: 'danger',
        message: t(error),
        delay: 2000,
      }))
    }
  }, [dispatch, error])

  return (
    <>
      {status === 'pending' && <div>
        <GreenSpinner />
      </div>}

      {status === 'fulfilled' && <div className="flex justify-center">
        <table className={style.table}>
          <thead>
            <tr>
              <th>
                <div className="inline-flex flex-col gap-0.5">
                  <span>ID</span>
                </div>
              </th>
              <th>
                <div className="inline-flex flex-col gap-0.5">
                  <span>
                    {t("shipments.shipments_list.table.header.tracking")}
                  </span>
                  <span>
                    {t("shipments.shipments_list.table.header.getting_package_type")}
                  </span>
                </div>
              </th>
              <th className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                  <span>
                    {t("shipments.shipments_list.table.header.worth_EUR")}
                  </span>
                  <span>
                    {t("shipments.shipments_list.table.header.worth_TRY")}
                  </span>
                </div>
              </th>
              <th className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                  <span>
                    {t("shipments.shipments_list.table.header.receiver")}
                  </span>
                </div>
              </th>
              <th className="hidden sm:table-cell">
                <div className="inline-flex flex-col gap-0.5">
                  <span>
                    {t("shipments.shipments_list.table.header.created_at")}
                  </span>
                  <span>
                    {t("shipments.shipments_list.table.header.updated_at")}
                  </span>
                </div>
              </th>
              <th>
                <div className="inline-flex flex-col gap-0.5">
                  <span>
                    {t("shipments.shipments_list.table.header.status")}
                  </span>
                </div>
              </th>
              <th>
                <div className="inline-flex flex-col gap-0.5">
                  <span>
                    {t("shipments.shipments_list.table.header.events")}
                  </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {shipments.map(shipment => <ShipmentsTableItem key={shipment.id} shipment={shipment} />)}
          </tbody>
        </table>
      </div>}
    </>
  );
};

export default ShipmentsTable;
